import { RecipientsOrderBy } from './types';

const ACTIONS_NAMESPACE = 'CHAT_BLAST_RECIPIENTS_TABLE';

export const SET_RECIPIENTS_ORDER_BY = `${ACTIONS_NAMESPACE}__SET_CONTACTS_ORDER_BY`;

export const setRecipientsOrderBy = (recipientsOrderBy: RecipientsOrderBy) => ({
  type: SET_RECIPIENTS_ORDER_BY,
  recipientsOrderBy,
});
